/* KCOD mobile sticky Add to Cart (PROPOSED / UNDEPLOYED). Mirrors the main form; owns no purchase logic. Loaded only by the kcod-buy templates.
   The theme re-renders the product section when a variant changes, so every lookup is made fresh on each update (no cached nodes). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var scheduled = false;

  function parts() {
    var bar = document.querySelector('[data-kcod-sticky]');
    var main = document.querySelector('.product__inner [data-add-to-cart]') || document.querySelector('[data-add-to-cart]');
    var form = main && main.closest('form');
    return bar && main && form ? { bar: bar, main: main, form: form, section: form.closest('.shopify-section') || form.parentElement } : null;
  }
  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }
  function update() {
    scheduled = false;
    var p = parts();
    if (!p) return;
    var btn = p.bar.querySelector('[data-kcod-sticky-btn]');
    var priceEl = p.bar.querySelector('[data-kcod-sticky-price]');
    var price = document.querySelector('[data-product-price]');
    var label = p.main.querySelector('[data-add-to-cart-text]');
    var priceText = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
    var labelText = label ? label.textContent.replace(/\s+/g, ' ').trim() : 'Add to Cart';
    var off = p.main.disabled || p.main.classList.contains('loading');
    if (priceEl.textContent !== priceText) priceEl.textContent = priceText;
    if (btn.textContent !== labelText) btn.textContent = labelText;
    if (btn.disabled !== off) { btn.disabled = off; btn.setAttribute('aria-disabled', off ? 'true' : 'false'); }
    var want = mq.matches && !visible(p.main) && p.section.getBoundingClientRect().bottom > window.innerHeight * 0.5;
    if (p.bar.hidden === want) p.bar.hidden = !want;
    document.documentElement.classList.toggle('kcod-sticky-on', want);
  }
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(update); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kcod-sticky-btn]');
    if (!btn || btn.disabled) return;
    var p = parts();
    if (p) p.form.requestSubmit(p.main);
  });
  var root = document.querySelector('main') || document.body;
  new MutationObserver(schedule).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  update();
})();
